import { render, staticRenderFns } from "./Wl.stags.vue?vue&type=template&id=5abfd3c3&scoped=true&lang=html&"
import script from "./Wl.stags.vue?vue&type=script&lang=js&"
export * from "./Wl.stags.vue?vue&type=script&lang=js&"
import style0 from "./Wl.stags.vue?vue&type=style&index=0&id=5abfd3c3&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abfd3c3",
  null
  
)

export default component.exports